module.exports = {
  details: {
    "Beneficiary Name": "Mr EU",
    "SWIFT Code": "PFSRIE21",
    IBAN: "IE86PFSR99107000979565",
    Currency: "EUR",
    "Creditor Type": "Single Person",
    "Address Line 1": "15 Long Road",
    "Address Line 2": "West",
    "Country Code": "GB",
  },
  owner: "e3005c3a-bf0e-4a16-b28a-eb6ee442de16",
  id: "b529c53c-241c-4f80-ab14-94fe9fb45f86",
  transfer_type: "SWIFT",
  account: "GBP",
};
